import {PWMAT_RESOURCE} from './consts'

export const Train = [{
  name:'1. PWmat基础培训 1',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=1',
  file_name:' 如何学习PWmat'
},
{
  name:'2. PWmat基础培训 2',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=2',
  file_name:' 自洽、能带、态密度计算'
},
{
  name:'3. PWmat基础培训 3',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=3',
  file_name:' 结构优化与分子动力学计算'
},
{
  name:'4. PWmat基础培训 4',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=4',
  file_name:' 含时密度泛函TDDFT计算'
},
{
  name:' 5. PWmat基础培训 5',
  url:'https://www.bilibili.com/video/BV1uY4y1v7h8?p=5',
  file_name:' 非绝热分子动力学NAMD计算'
},
{
  name:'6.Mcloud教程',
  url:'https://www.bilibili.com/video/BV1BP4y127Jn/?spm_id_from=333.999.0.0',
  file_name:'Mcloud使用指南'
},
{
  name:'7.Q-Studio建模教程1',
  url:'https://www.bilibili.com/video/BV1B8411b7Ci/?spm_id_from=333.999.0.0',
  file_name:'体材料及表面结构建模'
},
{
  name:'8.Q-Studio建模教程2',
  url:'https://www.bilibili.com/video/BV1Pe4y147Di/?spm_id_from=333.999.0.0',
  file_name:'二维材料及莫尔条纹建模'
},
{
  name:'9.Q-Studio建模教程3',
  url:'https://www.bilibili.com/video/BV1TG4y1t7vy/?spm_id_from=333.999.0.0',
  file_name:'异质结建模'
},
{
  name:'10.Q-Flow教程1',
  url:'https://www.bilibili.com/video/BV1ke4y1a74i/?spm_id_from=333.999.0.0',
  file_name:'结构优化'
},
{
  name:'11.Q-Flow教程2',
  url:'https://www.bilibili.com/video/BV1Nt4y1T798/?spm_id_from=333.999.0.0',
  file_name:'PBE及HSE能带计算'
},
{
  name:'12.Q-Flow教程3',
  url:'https://www.bilibili.com/video/BV1qe4y1a7WM/?spm_id_from=333.999.0.0',
  file_name:'PBE及HSE态密度计算'
},
{
  name:'13.Q-Flow教程4',
  url:'https://www.bilibili.com/video/BV1bd4y1k7zp/?spm_id_from=333.999.0.0',
  file_name:'DFT+U计算'
},
{
  name:'14.Q-Flow教程5',
  url:'https://www.bilibili.com/video/BV1jd4y1k7JA/?spm_id_from=333.999.0.0',
  file_name:'体材料及二维材料光学性质计算'
},
{
  name:'15.Q-Flow教程6',
  url:'https://www.bilibili.com/video/BV1UW4y177L3/?spm_id_from=333.999.0.0',
  file_name:'隐式溶剂效应下OER计算'
},
{
  name:'16.Q-Flow教程7',
  url:'https://www.bilibili.com/video/BV1tg41187Nx/?spm_id_from=333.999.0.0',
  file_name:'固定电势法计算OER'
},
{
  name:'17.Q-Flow教程8',
  url:'https://www.bilibili.com/video/BV1cW4y1T7QP/?spm_id_from=333.999.0.0',
  file_name:'NEB计算过渡态'
},
]
